import PropTypes from 'prop-types';

const FieldsInputPropShapes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  value: PropTypes.any,
  onDragStart: PropTypes.func,
  onDrop: PropTypes.func,
};

export default FieldsInputPropShapes;
